import { faCoins } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { useEffect, useState, useCallback } from 'react';
import { numberWithCommas } from '../helper';
import { getCoinSupply, getHalving } from '../vecno-api-client';
import { API_SERVER, VECNO_UNIT } from '../explorer_constants';

const CBox = () => {
    const [circCoins, setCircCoins] = useState('-');
    const [blockReward, setBlockReward] = useState('-');
    const [halvingDate, setHalvingDate] = useState('-');
    const [halvingAmount, setHalvingAmount] = useState('-');

    const initBox = useCallback(async () => {
        // Load cached values if available
        if (localStorage.getItem('cacheCircCoins')) {
            setCircCoins(localStorage.getItem('cacheCircCoins'));
        }
        if (localStorage.getItem('cacheBlockReward')) {
            setBlockReward(localStorage.getItem('cacheBlockReward'));
        }
        if (localStorage.getItem('cacheHalvingDate')) {
            setHalvingDate(localStorage.getItem('cacheHalvingDate'));
        }
        if (localStorage.getItem('cacheHalvingAmount')) {
            setHalvingAmount(localStorage.getItem('cacheHalvingAmount'));
        }

        try {
            // Fetch coin supply
            const coinSupplyResp = await getCoinSupply();
            const roundedCircCoins = Math.round(coinSupplyResp.circulatingSupply / 100000000);
            setCircCoins(roundedCircCoins);
            localStorage.setItem('cacheCircCoins', roundedCircCoins);

            // Fetch block reward
            await fetch(`${API_SERVER}/info/blockreward`)
                .then((response) => response.json())
                .then((d) => {
                    const reward = d.blockreward.toFixed(2);
                    setBlockReward(reward);
                    localStorage.setItem('cacheBlockReward', reward);
                })
                .catch((err) => console.error('Error fetching block reward:', err));

            // Fetch halving data
            const halvingData = await getHalving();
            const nextHalvingDate = moment(halvingData.nextHalvingTimestamp * 1000).format('YYYY-MM-DD HH:mm');
            const nextHalvingAmount = halvingData.nextHalvingAmount.toFixed(2);
            setHalvingDate(nextHalvingDate);
            setHalvingAmount(nextHalvingAmount);
            localStorage.setItem('cacheHalvingDate', nextHalvingDate);
            localStorage.setItem('cacheHalvingAmount', nextHalvingAmount);
        } catch (err) {
            console.error('Error initializing box:', err);
        }
    }, []);

    useEffect(() => {
        initBox();

        const updateCircCoins = setInterval(async () => {
            try {
                const coinSupplyResp = await getCoinSupply();
                const roundedCircCoins = Math.round(coinSupplyResp.circulatingSupply / 100000000);
                setCircCoins(roundedCircCoins);
                localStorage.setItem('cacheCircCoins', roundedCircCoins);
            } catch (err) {
                console.error('Error updating circulating coins:', err);
            }
        }, 10000);

        return () => {
            clearInterval(updateCircCoins); // Synchronous cleanup
        };
    }, [initBox]);

    useEffect(() => {
        const element = document.getElementById('coins');
        if (element) {
            element.animate(
                [
                    { opacity: '1' },
                    { opacity: '0.6' },
                    { opacity: '1' },
                ],
                {
                    duration: 300,
                }
            );
        }
    }, [circCoins]);

    return (
        <div className="cardBox mx-0">
            <table style={{ fontSize: '1rem' }}>
                <tr>
                    <td colSpan="2" className="text-center" style={{ fontSize: '4rem' }}>
                        <FontAwesomeIcon icon={faCoins} />
                        <div id="light1" className="cardLight" />
                    </td>
                </tr>
                <tr>
                    <td colSpan="2" className="text-center">
                        <h3>Coin supply</h3>
                    </td>
                </tr>
                <tr>
                    <td className="cardBoxElement align-top">Total</td>
                    <td>
                        <div id="coins">
                            {numberWithCommas(circCoins)} {VECNO_UNIT}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className="cardBoxElement align-top">
                        Max <span className="approx">(approx.)</span>
                    </td>
                    <td className="pt-1">200,000,000 {VECNO_UNIT}</td>
                </tr>
                <tr>
                    <td className="cardBoxElement align-top">Mined</td>
                    <td className="pt-1">{(circCoins / 200000000 * 100).toFixed(2)} %</td>
                </tr>
                <tr>
                    <td className="cardBoxElement align-top">Block reward</td>
                    <td className="pt-1">
                        {process.env.REACT_APP_NETWORK === 'mainnet' ? `${blockReward} ${VECNO_UNIT}` : '-'}
                    </td>
                </tr>
                <tr>
                    <td className="cardBoxElement align-top">Reward reduction</td>
                    <td className="pt-1">
                        {process.env.REACT_APP_NETWORK === 'mainnet' ? (
                            <>
                                {halvingDate}
                                <br />
                                <div className="text-end w-100 pe-3 pt-1" style={{ fontSize: 'small' }}>
                                    to {halvingAmount} {VECNO_UNIT}
                                </div>
                            </>
                        ) : (
                            '-'
                        )}
                    </td>
                </tr>
            </table>
        </div>
    );
};

export default CBox;